import { jsx } from 'react/jsx-runtime';

/** ![link2Icon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNOSAxN0g3QTUgNSAwIDAgMSA3IDdoMk0xNSA3aDJhNSA1IDAgMSAxIDAgMTBoLTJNOCAxMmg4Ii8+PC9zdmc+) */
const link2Icon = /*#__PURE__*/jsx("path", {
  d: "M9 17H7A5 5 0 0 1 7 7h2M15 7h2a5 5 0 1 1 0 10h-2M8 12h8"
});

export { link2Icon };
